import { Trans } from '@lingui/macro'
import { MenuItem, TextField, TextFieldProps } from '@mui/material'
import { Field } from 'formik'
import React from 'react'
import { hasFieldValue } from 'utilsTS'

/**
 * Convinience wrapper for Material UI Text Field connected to Formik
 * @category Common components
 * @subcategory Formik
 * @component
 * @returns {JSX.Element}
 * @property {string} name This is an id of Formiks field that the TextField is connected to
 */
export const TextFieldSelectWithFormik = (
  props: TextFieldProps & TextFieldWithFormikProps
): JSX.Element => {
  const { name, helperText, label, required, isTopLabel, options } = props
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        const value = field.value
        const displayError = Boolean(
          (meta.touched as boolean || hasFieldValue(value)) && meta.error)
        let helperArray: React.ReactNode[] = []
        if (required) {
          helperArray = [<Trans>Required</Trans>, '. ']
        }
        if (helperText) {
          helperArray.push(helperText)
        }
        return (
          <div>
            {isTopLabel && (
              <div style={{ paddingBottom: '2px', fontSize: '12px' }}>
                {label}
              </div>
            )}
            <TextField
              {...field}
              {...props}
              select
              error={displayError}
              helperText={displayError ? meta.error : helperArray}
              value={value ?? ''}
              label={!isTopLabel ? label : ''}
            >
              {options?.map(item =>
                <MenuItem value={item.value} key={item.value}>
                  {item.label}
                </MenuItem>)}
            </TextField>
          </div>
        )
      }}
    </Field>
  )
}

interface SelectOption {
  label: React.ReactNode
  value: string
}

interface TextFieldWithFormikProps {
  /**
   * This is an id of Formiks field that the TextField is connected to
   */
  name: string
  isTopLabel?: boolean // If true, label will be on top of the input, otherwise it will be inside the input
  options?: SelectOption[]
}
